let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bnI4A")).then(() => parcelRequire('fIX00'));